import { Route, Redirect } from "react-router-dom";
import React from "react";
import { store } from "../../../redux/store";
import { isUserAuthenticated } from "../../../guards/auth-guard";
import { errorHandler, isAgentAdressComplete } from "../../../helper-methods";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { userData } = store.getState();
  // console.log(state.userData.type,rest.path);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isUserAuthenticated(rest?.path)) {
          return (
            <Redirect
              to={{
                pathname: rest?.redirectRoute,
                extras: { ...rest?.location },
              }}
            />
          );
        }

        // ---------- if agent hasn't added address info, don't let me move to other tabs ----------------
        const type = userData?.type?.toLowerCase();
        if (
          type === "agent" &&
          !isAgentAdressComplete() &&
          props?.location?.pathname !== "/agent/profile"
        ) {
          return (
            <>
              {errorHandler({
                reason:
                  "Please complete your address details before proceeding.",
              })}

              <Redirect
                to={{
                  pathname: "/agent/profile",
                  search: "?tabId=1",
                }}
              />
            </>
          );
        }
        // --------------------------

        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
